/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import "../Notfound//Notfound.css";
import React from "react";
import { ERROR_PAGE_LOGO, ERROR_LOGO } from "../../../constants/Constants";
export default class TooManyRequestErrorContainer extends React.Component {
  render() {
    return (
      <div className="error-wrapper-network">
        <span
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={this.props.close}
        >
          <strong aria-hidden="true">×</strong>
        </span>
        <div className="error_logo">
          <div className="error-img">
            <img alt="" src={ERROR_PAGE_LOGO} />
          </div>
        </div>
        <div className="error_message">
          <div className="container">
            <div className="error_inner">
              <div className="wizard-sad-logo">
                <img alt="" src={ERROR_LOGO} />
              </div>
              <div className="error_content">
                <h3>Too Many Requests</h3>
                <p className="e-con">
                  There have been several failed attempts to sign in from this
                  account or IP address. Please wait a while and try again
                  later.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
